import React from 'react';
import { CheckIcon, CreditCardIcon } from 'lucide-react';
import { PRICE, PRICE_ORIGINAL, PRODUCT_IMAGE, offerIncludes, offerRows } from '../data/content';
import { CtaButton } from './CtaButton';
import { Brand } from './Brand';
export function Offer() {
  return <section id="offer" className="w-full bg-slate-900 px-5 py-24 text-stone-50 sm:px-14 sm:py-32" data-id="element-232" data-mp="1mpd6k6sau58i">
      <div className="mx-auto grid max-w-6xl gap-14 lg:grid-cols-12 lg:items-center" data-id="element-233" data-mp="1hqs5y694xjjj">
        <div className="px-3 sm:px-0 lg:col-span-6" data-id="element-234" data-mp="u0xthpsq9wzt">
          <h2 className="font-serif text-[2.6rem] leading-[1.02] tracking-tight sm:text-6xl" data-id="element-235" data-mp="p0jx550hobhm">
            你的完整 <em className="text-red-300" data-id="element-236" data-mp="13xau77moxb42"><Brand data-id="element-237" data-mp="13ylzjbvsaqxa" /></em> 教材套裝
          </h2>
          <p className="mt-6 max-w-md text-lg leading-relaxed text-stone-50/70" data-id="element-238" data-mp="yy7r3sq9teyq">
            5 分鐘備好一節課，一整個學年的音樂課都有著落。
          </p>
          <img src={PRODUCT_IMAGE} alt="" loading="lazy" className="mx-auto mt-12 hidden w-full max-w-md drop-shadow-2xl lg:block" data-id="element-239" data-mp="2fb50iwvph46l" />
        </div>

        <div id="offer-card" className="scroll-mt-16 rounded-3xl bg-stone-50 p-6 text-slate-900 shadow-2xl shadow-black/40 sm:p-11 lg:col-span-6" data-id="element-240" data-mp="2afftk8hcwl09">
          <p className="text-sm font-semibold text-slate-900/60" data-id="element-241" data-mp="ui8ym5j3oike">完整套裝包括</p>

          <ul className="mt-5 divide-y divide-slate-900/10 border-y border-slate-900/10" data-id="element-242" data-mp="zhvbgdv0nwso">
            {offerRows.map(row => <li key={row.label} className="flex gap-4 py-4" data-id="element-243" data-mp="13k9vv2ec34m2">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-700" data-id="element-244" data-mp="13hnksss8i6z3">
                  <CheckIcon className="h-3 w-3 text-white" strokeWidth={3} aria-hidden="true" data-id="element-245" data-mp="bskgxe49eymz" />
                </span>
                <span data-id="element-246" data-mp="fu5ocjy0ykps">
                  <span className="block font-medium leading-snug" data-id="element-247" data-mp="fsuogv7p9x3y">{row.label}</span>
                  <span className="mt-0.5 block text-sm leading-snug text-slate-900/65" data-id="element-248" data-mp="km5uiu4ou9ut">{row.detail}</span>
                </span>
              </li>)}
          </ul>

          <div className="mt-8 flex flex-col items-center gap-2 text-center sm:flex-row sm:items-end sm:justify-between sm:gap-4 sm:text-left" data-id="element-249" data-mp="3o9z8d8rkeebl">
            <p className="text-sm font-medium text-slate-900/70 sm:pb-2" data-id="element-250" data-mp="vefrpxtx9wyz">
              原價 <s className="text-slate-900/50" data-id="element-251" data-mp="qhfmfp4wcy8x">{PRICE_ORIGINAL}</s>
              <span className="mx-1.5" aria-hidden="true" data-id="element-252" data-mp="155k6oxjllhtt">·</span>推廣價
            </p>
            <p className="whitespace-nowrap font-serif text-6xl leading-none tracking-tight text-slate-900 sm:text-8xl" data-id="element-253" data-mp="157mynn4b9l16">
              {PRICE}
            </p>
          </div>
          <p className="mt-3 flex items-center justify-center gap-2 text-sm text-slate-900/70 sm:justify-end" data-id="element-254" data-mp="chel68kpzosx">
            <CreditCardIcon className="h-4 w-4" aria-hidden="true" data-id="element-255" data-mp="7jmicjijei9y" />
            一次付款，無需訂閱。
          </p>

          <CtaButton label="立即取得完整套裝" className="mt-8 w-full" data-id="element-256" data-mp="lfgjuhgze5d1" />

          <ul className="mt-5 flex flex-wrap justify-center gap-x-4 gap-y-1 text-xs text-slate-900/60" data-id="element-257" data-mp="hf6dh3pa1cxn">
            {offerIncludes.map(item => <li key={item} data-id="element-258" data-mp="1wyt14a7i7utm">{item}</li>)}
          </ul>
        </div>
      </div>
    </section>;
}